import _defineProperty from "@babel/runtime/helpers/defineProperty";

/* LIBRARIES */
import classNames from 'classnames';
/* TYPES */

import * as stylesModule from '../button.css';
/* TYPES */

export var getCustomClasses = function getCustomClasses(custom) {
  var _classNames;

  var _custom$mediaType = custom.mediaType,
      mediaType = _custom$mediaType === void 0 ? 'all' : _custom$mediaType;
  return classNames((_classNames = {}, _defineProperty(_classNames, stylesModule["container-mediaType--".concat(mediaType)], true), _defineProperty(_classNames, stylesModule["container-activeBorderColor--".concat(custom.activeBorderColor)], custom.activeBorderColor), _defineProperty(_classNames, stylesModule["container-hoveredBackgroundColor--".concat(custom.hoveredBackgroundColor)], custom.hoveredBackgroundColor), _defineProperty(_classNames, stylesModule["container-type--".concat(custom.type)], custom.type), _defineProperty(_classNames, stylesModule["container-mediaType--".concat(mediaType)], mediaType), _defineProperty(_classNames, stylesModule['container-disabled'], custom.disabled), _defineProperty(_classNames, stylesModule['container-loading'], custom.loading), _defineProperty(_classNames, stylesModule["container-activeBackgroundColor--".concat(custom.activeBackgroundColor)], custom.activeBackgroundColor), _classNames));
};
export var getStylesClasses = function getStylesClasses(styles) {
  return classNames(_defineProperty({}, stylesModule["container-backgroundColor--".concat(styles.backgroundColor)], styles.backgroundColor));
};
export var getInlineStyles = function getInlineStyles(props) {
  var _props$styles = props.styles,
      styles = _props$styles === void 0 ? {} : _props$styles;
  return {
    width: styles.width
  };
};